require('./ChannelSchedule.scss');

const b = require('app/www/libs/b')('channel-schedule');
const b_dark = require('app/www/libs/b')('channel-schedule-dark');

const _ = {
    get: require('lodash/get'),
    find: require('lodash/find'),
};
const React = require('react');
const PropTypes = require('prop-types');

const Metrika = require('app/www/libs/client/metrika');

const {withReqRef} = require('app/www/components/contexts/Req');
const {withI18nRef} = require('app/www/components/contexts/I18n');

const ThumbWatchOnline = require('app/www/components/blocks/ThumbWatchOnline/ThumbWatchOnline');
const Icon = require('app/www/components/blocks/Icon/Icon');
const Image = require('app/www/components/blocks/Image/Image');
const Link = require('app/www/components/blocks/Link/Link');
const TimeLine = require('app/www/components/blocks/TimeLine/TimeLine');

const MIN_PAST_EVENTS_TO_HIDE = 4;
const ANIMATION_DELAY = 500;

class ChannelSchedule extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {};
        this._isSerpApp = this.props.req.lib('urlBuilder').isSerpApp;
        this._isViewInIframeKinopoiskhd = this.props.req.lib('urlBuilder').isViewInIframeKinopoiskhd;

        this._onClick = this._onClick.bind(this);
        this._onMouseEnter = this._onMouseEnter.bind(this);
        this._onMouseLeave = this._onMouseLeave.bind(this);
        this._onClickButton = this._onClickButton.bind(this);
        this._generateListItem = this._generateListItem.bind(this);
    }

    static getDerivedStateFromProps(props, state) {
        if (props.events.filter(event => event.hasFinished).length < MIN_PAST_EVENTS_TO_HIDE) {
            return {
                hiddenEvents: [],
                shownEvents: props.events,
                isOpened: true,
                offset: null,
            };
        }

        return {
            hiddenEvents: props.events.filter((event, i, events) => {
                return event.hasFinished && !(i < events.length && !events[i].hasFinished);
            }),
            shownEvents: props.events.filter((event, i, events) => {
                return !event.hasFinished || (event.hasFinished && i < events.length && !events[i].hasFinished);
            }),
            isOpened: Boolean(state.offset) || props.events.every(event => event.hasFinished),
        };
    }

    render() {
        const {i18n, events, hasFinished} = this.props;
        const {offset, isOpened, hiddenEvents, shownEvents} = this.state;

        const listStyle = (shownEvents.length && offset) ? {
            marginTop: `-${offset}px`,
        } : {};

        return events.length ? (
            <div className={b({dark: this._isViewInIframeKinopoiskhd})}>
                {hiddenEvents.length > 0 && shownEvents.length > 0 && (
                    <div className={b('button', {
                        hidden: isOpened,
                        dark: this._isViewInIframeKinopoiskhd,
                    })}
                    onClick={this._onClickButton}
                    >
                        <span className={b('button-text')}>
                            {i18n.get('channel-schedule.past-events')}
                        </span>
                    </div>
                )}
                <ul className={b('list', {opened: isOpened})}>
                    <div
                        className={b('hidden-list', {dark: this._isViewInIframeKinopoiskhd})}
                        ref={ref => (this._hiddenList = ref)}
                        style={listStyle}
                    >
                        {hiddenEvents.map(this._generateListItem)}
                    </div>
                    {shownEvents.map(this._generateListItem)}
                </ul>
            </div>
        ) : (
            <div className={b('empty-splash', {
                dark: this._isViewInIframeKinopoiskhd,
            })}>
                {i18n.get(`empty-splash.${hasFinished ? 'no-events' : 'broadcast-gap'}`)}
            </div>
        );
    }

    /**
     * Получаем все события расписания
     * @returns {Object[]}
     */
    get items() {
        return this._items;
    }

    /**
     * @param {Number} eventId id события
     * @param {Number} programCoId coId программы
     * @returns {Object}
     * @private
     */
    _onMouseEnter(eventId, programCoId) {
        const {
            onMouseEnter,
            isLayoutColumnsLarge,
        } = this.props;

        if (!(isLayoutColumnsLarge || this._isSerpApp || this._isViewInIframeKinopoiskhd)) {
            return evt => {
                onMouseEnter(evt, eventId, programCoId);

                this.setState({
                    [eventId]: true,
                });
            };
        }
    }

    /**
     * @param {Number} eventId id события
     * @returns {Object}
     * @private
     */
    _onMouseLeave(eventId) {
        const {
            onMouseLeave,
            isLayoutColumnsLarge,
        } = this.props;

        if (!(isLayoutColumnsLarge || this._isViewInIframeKinopoiskhd)) {
            return evt => {
                onMouseLeave(evt);

                this.setState({
                    [eventId]: false,
                });
            };
        }
    }

    /**
     * @param {Boolean} isRecommended
     * @param {String} programType
     * @param {Number} programId
     * @returns {Object}
     * @private
     */

    _onClick(isRecommended, programType, programId) {
        return () => {
            Metrika.trackParams('TV_EVENT', {
                mods: {
                    picture: isRecommended,
                },
                genre: programType,
                programId,
            });
        };
    }

    /**
     * Раскрываем расписание
     * @private
     */
    _onClickButton() {
        this.setState({
            isOpened: true,
            offset: _.get(this._hiddenList, 'clientHeight', 0),
        }, () => {
            setTimeout(this.props.onClickButton, ANIMATION_DELAY);
        });
    }

    /**
     * @param {Object} event объект события
     * @returns {Object}
     * @private
     */
    _generateListItem(event) {
        const {program} = event;
        const {
            familyId,
            wannaSee,
            recommended,
            isHDLinkFull,
            channelContentId,
        } = this.props;

        const watchableChannel = channelContentId && isHDLinkFull && event.isNow && !event.hasFinished;

        const recommendedEvent = _.find(recommended, item => item.eventId === event.id);

        const imageProps = {
            mods: {
                size: 'l',
            },
            sizes: _.get(recommendedEvent, 'image.sizes'),
        };

        const iconLiveProps = {
            className: b('live'),
            mods: {
                size: 'm',
                live: true,
                live_dark: this._isViewInIframeKinopoiskhd,
                hovered: this.state[event.id],
            },
        };

        const iconWannaSeeProps = {
            className: b('wanna-see', {hidden: !wannaSee.includes(program.id)}),
            mods: {
                text: true,
                'wanna-see': true,
            },
        };

        this._items = [];

        if (this._isViewInIframeKinopoiskhd) {
            return (<li
                className={b_dark()}
            >
                <time key="time" className={b_dark('time')}>{event.startTime}</time>
                <div className={b_dark('info')}>
                    <h3 key="title" className={b('title')}>
                        <span className={b('text')}>
                            {event.live && <Icon {...iconLiveProps}/>}
                            {event.title}
                        </span>&nbsp;
                    </h3>
                    {this._renderProgress(event)}
                </div>
            </li>);
        }

        return (
            <li
                key={event.id}
                ref={elem => (this._items.push(elem))}
                className={b('event', {
                    past: event.hasFinished,
                    'watch-channel': watchableChannel,
                    dark: this._isViewInIframeKinopoiskhd,
                })}
            >
                <Link
                    className={b('link')}
                    url={event.url}
                    onMouseEnter={this._onMouseEnter(event.id, program.coId)}
                    onMouseLeave={this._onMouseLeave(event.id)}
                    onClick={this._onClick(Boolean(recommendedEvent), program.type.name, program.id)}
                />
                <time key="time" className={b('time')}>{event.startTime}</time>
                {watchableChannel && (
                    <ThumbWatchOnline
                        className={b('thumb')}
                        image={`${program.mainImageBaseUrl}/normal`}
                        channelContentId={channelContentId}
                        familyId={familyId}
                        fromBlock={'tv-channel'}
                        viewType={'thump'}
                        exp={'full'}
                    />
                )}
                <div className={b('info')}>
                    <h3 key="title" className={b('title')}>
                        <span className={b('text')}>
                            {event.live && <Icon {...iconLiveProps}/>}
                            {event.title}
                        </span>&nbsp;
                        {!this._isSerpApp && (
                            <span className={b('icons')}>
                                <Icon {...iconWannaSeeProps}/>
                            </span>
                        )}
                    </h3>
                    {this._renderProgress(event)}
                    {recommendedEvent && (
                        <Image
                            key="image"
                            className={b('image')}
                            {...imageProps}
                        />
                    )}
                </div>
            </li>
        );
    }

    /**
     * @param {Object} event
     * @private
     */
    _renderProgress(event) {
        if (event.hasFinished || !event.isNow) {
            return null;
        }
        const {
            currentEvent,
            onStartEvent,
        } = this.props;

        const {
            title,
            start,
            finish,
        } = event;

        const props = {
            title,
            start,
            finish,
            currentEvent,
            onStartEvent,
        };

        return (
            <TimeLine className={b('time-line', {dark: this._isViewInIframeKinopoiskhd})} {...props} />
        );
    }
}

ChannelSchedule.propTypes = {
    events: PropTypes.arrayOf(PropTypes.object),
    hasFinished: PropTypes.bool,
    wannaSee: PropTypes.arrayOf(PropTypes.number),
    recommended: PropTypes.arrayOf(PropTypes.object),
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    onClick: PropTypes.func,
    onClickButton: PropTypes.func,
    onStartEvent: PropTypes.func,
};

module.exports = withReqRef(withI18nRef(ChannelSchedule));
